// extracted by mini-css-extract-plugin
export default {"modalbody":"FullscreenModal_modalbody__d8J+f","close-btn":"FullscreenModal_close-btn__miLt+"};